<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

    export default {
        name: "home",
        methods: {}
    }
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    color: black;
    list-style: none;
    text-decoration: none;
  }
  .clear:after{
    content: ' ';
    clear: both;
    display:block;
    height:0;
    visibility:hidden;
  }
  #app {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue